<template>
  <div>
    <button
      type="button"
      :disabled="isAwarded || isUnderEditing"
      id="award_tender"
      class="btn btn--orange float-right"
      @click="init()"
    >{{ $t('action.awardRegret') }}</button>

    <div
      class="reveal"
      ref="awardTenderModal"
      id="awardTenderModal"
      style="overflow: visible;"
    >
      <div>
        <button
          class="close-reveal-modal float-right close-dialog"
          aria-label="Close"
          @click="closeAwardTenderModal()"
        >&#215;</button>
      </div>
      <div class="modal-container">
        <p class="confirm-header">{{ $t('tender.award.popupTitle') }}</p>
      </div>
      <div class="row align-right nav_btn">
        <DialogSlot
          id="tender-regret-all-modal"
          ref="tender-regret-all-modal"
          :modalBtn="$t('action.regretAll')"
          modalBtnClass="btn--darkblue"
          :beforeOpenModal="beforeOpenModal"
          :showCloseBtn="false"
        >
          <div slot="content">
            <span class="confirm-header">{{ $t('hint.regretAll') }}</span>
          </div>
          <div slot="buttons">
            <button
              type="button"
              class="btn btn--darkblue"
              data-close
              aria-label="Close reveal"
            >{{ $t('action.cancel') }}</button>
            <button
              type="button"
              class="btn btn--orange"
              @click="rejectAll()"
            >{{ $t('action.yesContinue') }}</button>
          </div>
        </DialogSlot>
        <CreateProject
          :isTenderAward="true"
          :recommendedBidId="recommendedBidId"
          @close:awardModal="closeAwardTenderModal()"
        />
      </div>
    </div>

    <div
      class="reveal"
      ref="regretAllAlertModal"
      id="regretAllAlertModal"
    >
      <div class="modal-container">
        <p class="confirm-header">{{ $t('tender.award.emailSentMsg') }}</p>
      </div>
      <div class="row align-center">
        <button
          type="btn"
          class="btn btn--orange"
          @click="navHome()"
        >{{ $t('hint.okay') }}</button>
      </div>
    </div>

  </div>
</template>

<script>
import CreateProject from '@/modules/projects/CreateProject'
import { sendEmail } from '@/api/postman/request'
import { EmailTypes, ActionTypes } from '@/utils/consts'
import { tenderStatus } from '@/utils/locale'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import mutationTypes from '@/store/mutation-types'
import navigation from '@/utils/navigation'
import notification from '@/utils/notification'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import DialogSlot from '@/controls/DialogSlot'

export default {
  name: 'AwardTender',
  components: {
    CreateProject,
    DialogSlot,
  },

  props: {
    isUnderEditing: {
      type: Boolean,
      default: false,
    },
    clickCheck: {
      type: Function,
      default: () => { return true },
    },
    className: {
      type: String,
      default: 'btn btn--orange',
    },
    recommendedBidId: {
      type: String,
      default: '',
    },
    saveAnalysisRecoData: Function,
  },

  beforeDestroy () {
    try {
      this.beforeDestroyMethod()
    } catch (e) {
      console.error(e)
    }
  },

  computed: {
    ...mapGetters('tenders', {
      currentTender: 'currentTender',
    }),
    isAwarded () {
      return [tenderStatus.AWARDED, tenderStatus.REGRETTED]
        .indexOf((this.currentTender.general || {}).status) > -1
    },
  },
  methods: {
    ...mapActions('tenders', [
      'updateTenderStatus',
      'refreshTender',
    ]),
    ...mapMutations('tenders', {
      updateTenderPathField: mutationTypes.TENDER_UPDATE_PATH_FIELD,
    }),
    beforeDestroyMethod () {
      if (this.regretAllAlertModal) {
        this.regretAllAlertModal.close()
        this.regretAllAlertModal.destroy()
        $(this.$refs.regretAllAlertModal).remove()
        delete this.regretAllAlertModal
      }
      if (this.awardTenderModal) {
        this.awardTenderModal.close()
        this.awardTenderModal.destroy()
        $(this.$refs.awardTenderModal).remove()
        delete this.awardTenderModal
      }
    },
    beforeOpenModal () {
      this.closeAwardTenderModal()
      return true
    },
    async init () {
      const checkResult = await this.clickCheck()
      if (!checkResult) return
      fusionInputCheckUtil.validateAllFields()
      if (!fusionInputCheckUtil.isAllFieldsValid('#analysis-recos-content')) {
        notification.fireNotification(false, this.$t('hint.checkValid'))
        return
      }
      try {
        await this.saveAnalysisRecoData()
      } catch (err) {
        console.error(err)
        return
      }

      if (!this.regretAllAlertModal) {
        this.regretAllAlertModal = await new Foundation.Reveal($('#regretAllAlertModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      if (!this.awardTenderModal) {
        this.awardTenderModal = await new Foundation.Reveal($('#awardTenderModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      this.openAwardTenderModal()
    },
    openAwardTenderModal () {
      this.awardTenderModal.open()
    },
    openRegretAllAlertModal () {
      this.regretAllAlertModal.open()
    },
    closeRegretAllAlertModal () {
      this.regretAllAlertModal.close()
    },
    closeAwardTenderModal () {
      this.awardTenderModal.close()
    },

    navHome () {
      this.closeRegretAllAlertModal()
      navigation.toHome()
    },

    async rejectAll () {
      this.$refs['tender-regret-all-modal'].closeModal()

      this.$root.$children[0].$refs.loadingLayer.$emit('startLoading')
      try {
        await this.updateTenderStatus({
          id: this.currentTender.general.id,
          status: tenderStatus.REGRETTED,
          action: ActionTypes.tenders.regret,
        })

        await sendEmail(EmailTypes.tenders.regretVendor)
        await this.refreshTender()
      } finally {
        this.$root.$children[0].$refs.loadingLayer.$emit('stopLoading')
      }
      this.openRegretAllAlertModal()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
#awardTenderModal .confirm-header {
  margin-bottom: 0;
}
.close-dialog {
  float: right;
  font-size: 20px;
  color: #0C3A58;
  cursor: pointer;
}
.dialog-slot {
  margin-right: 15px;
}
</style>

<style lang="scss">
#awardTenderModal {
  position: relative;
  width: 500px;
  .close-dialog {
    font-size: 30px;
    position: absolute;
    top: 5px;
    right: 10px;
  }
}
[modalid="tender-regret-all-modal"], #regretAllAlertModal, #awardTenderModal {
  .confirm-header{
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
